/**
 * @generated SignedSource<<6a601b0c88fdff4cea1f6a595cd9e562>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StaffSelectPageTools_sheet$data = {
  readonly id: string;
  readonly bar_finder_user_confirmation_steps: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly bar_finder_steps: ReadonlyArray<{
    readonly id: string;
    readonly data: {
      readonly bars?: ReadonlyArray<{
        readonly bar_id: string;
      }>;
    } | null;
  }>;
  readonly " $fragmentType": "StaffSelectPageTools_sheet";
};
export type StaffSelectPageTools_sheet$key = {
  readonly " $data"?: StaffSelectPageTools_sheet$data;
  readonly " $fragmentSpreads": FragmentRefs<"StaffSelectPageTools_sheet">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StaffSelectPageTools_sheet",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "bar_finder_user_confirmation_steps",
      "args": [
        {
          "kind": "Literal",
          "name": "step_type",
          "value": "BAR_FINDER_USER_CONFIRMATION"
        }
      ],
      "concreteType": "MusicParseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": "steps(step_type:\"BAR_FINDER_USER_CONFIRMATION\")"
    },
    {
      "alias": "bar_finder_steps",
      "args": [
        {
          "kind": "Literal",
          "name": "step_type",
          "value": "BAR_FINDER"
        }
      ],
      "concreteType": "MusicParseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MusicParseStepDataBarFinderBar",
                  "kind": "LinkedField",
                  "name": "bars",
                  "plural": true,
                  "selections": [
                    {
                      "alias": "bar_id",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mask_storage_name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "MusicParseStepDataBarFinder",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "steps(step_type:\"BAR_FINDER\")"
    }
  ],
  "type": "MusicSheet",
  "abstractKey": null
};
})();

(node as any).hash = "2858d4d96ad7efb67949edf32e6272da";

export default node;
